import { useGetUnreadNotificationsCount } from '@repo/api/notification/useGetUnreadNotificationsCount';
import { NotificationType } from '@repo/types/enums/notificationType';
import { format } from 'date-fns';
import { Bell } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';

import NotificationsSheetTrigger from '@/components/features/notifications/NotificationsSheetTrigger';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Chip } from '@/components/ui/chip';
import { useCredentials } from '@/store/auth-store';

export default function HomeHeader() {
  const { name, surname } = useCredentials();
  const [time, setTime] = useState<string>(format(new Date(), 'HH:mm'));
  const { data } = useGetUnreadNotificationsCount(NotificationType.All);

  const notificationsNumber = useMemo(() => {
    if (data >= 100) {
      return '+99';
    }
    return String(data);
  }, [data]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(format(new Date(), 'HH:mm'));
    }, 10000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div className={'bg-background flex w-full flex-row justify-between rounded-2xl border p-4'}>
        <div className={'flex flex-col gap-2'}>
          <h2 className={'text-foreground text-3xl font-semibold'}>{time}</h2>
          <Badge variant={'muted'}>
            Witaj, {name} {surname}!
          </Badge>
        </div>
        <div className={'flex items-start gap-2'}>
          <Chip isInvisible={!data} variantColor={'brand'} variant={'solid'} content={notificationsNumber}>
            <NotificationsSheetTrigger asChild>
              <Button variant={'outline'}>
                <Bell />
                Powiadomienia
              </Button>
            </NotificationsSheetTrigger>
          </Chip>
        </div>
      </div>
    </>
  );
}
